// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"9aa776a1","174":"7e66d3d1","675":"38dca1e8","781":"10dd1944","809":"f0111f44"}[chunkId] + ".chunk.js";
};